import { Alert } from '@pets-ui/Alert/Alert'
import { Text } from '@pets-ui/Text/Text'
import { useTranslation } from 'react-i18next'
import { type CosignContextProps } from '../../../components/useContextCosign'

const REQUIRES_EMAIL_VERIFICATION: Record<CosignContextProps['projectCode'], boolean> = {
  DCS: true,
  LM: true,
  HM: false,
  MNP: false,
  AQUA: false,
  PP: true,
  PM: true,
  YT: true,
  RS: true,
}

interface VerifyContentProps {
  isBoundEmail: boolean
  isBoundPhone: boolean
  projectCode: CosignContextProps['projectCode']
}

export function VerifyContent(props: VerifyContentProps) {
  const { isBoundPhone, isBoundEmail, projectCode } = props
  const { t } = useTranslation()

  const requiresEmail = REQUIRES_EMAIL_VERIFICATION[projectCode]
  const isVerified = requiresEmail ? isBoundPhone && isBoundEmail : isBoundPhone

  if (isVerified) {
    return null
  }

  return (
    <Alert type="grey">
      <Text variant="caption">
        {requiresEmail ? t('login.verifyPhoneAndEmailContent') : t('login.verifyPhoneContent')}
      </Text>
    </Alert>
  )
}
